var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M148 64h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -39.158 -16.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.166 82.372a12 12 0 0 0-2.748-15.811c-4.326-3.427-10.57-3.412-14.877.038-5.692 4.554-6.032 12.882-1.026 17.891 4.036 4.033 10.223 4.585 14.858 1.675l3.693 1.05a.93.93 0 0 0 1.15-1.15zm-10.165 1.844a1.232 1.232 0 1 1 .002-2.464 1.232 1.232 0 0 1-.002 2.464m2.771-8.274c-.98.753-1.54 1.81-1.54 2.902v.082c0 .683-.552 1.234-1.231 1.234a1.233 1.233 0 0 1-1.231-1.234v-.082c0-1.864.911-3.631 2.501-4.854a2.08 2.08 0 0 0 .814-1.683c-.015-1.1-.957-2.042-2.057-2.057h-.027c-.552 0-1.073.212-1.463.602a2.07 2.07 0 0 0-.621 1.482 1.23 1.23 0 0 1-1.231 1.231 1.227 1.227 0 0 1-1.231-1.231c0-1.223.478-2.373 1.354-3.238a4.6 4.6 0 0 1 3.254-1.308c2.439.035 4.449 2.045 4.484 4.484a4.58 4.58 0 0 1-1.775 3.67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.a991316f0ebb2ece4e6ab6d6dcc19809.svg";
export { ForwardRef as ReactComponent };